import { ERROR_CODES } from "@procuremate/shared";
import type { TFunction } from "i18next";
import { ApiRequestError } from "@/lib/api-client";

/**
 * Maps admin API errors to user-facing text. The API's messages are English and for
 * developers; `conflictKey` names the i18n text for a 409 in this specific action.
 */
export function adminErrorMessage(error: unknown, t: TFunction, conflictKey?: string): string | undefined {
  if (!error) return undefined;
  if (error instanceof ApiRequestError) {
    switch (error.code) {
      case ERROR_CODES.CONFLICT:
        return conflictKey ? t(conflictKey) : t("admin.errors.conflict");
      case ERROR_CODES.FORBIDDEN:
        return t("admin.errors.forbidden");
      case ERROR_CODES.NOT_FOUND:
        return t("admin.errors.notFound");
      case ERROR_CODES.VALIDATION_FAILED:
        return t("admin.errors.validation");
    }
  }
  return t("auth.genericError");
}
